module.exports = __webpack_public_path__ + "static/media/logo_kop.05e69850.jpg";